'use client'

import { CustomCmsSeller } from '../../../domain/seller'
import { useTranslation } from '../../context/ConfigContext'

const StoreInformationsServices = ({ seller }: { seller: CustomCmsSeller }) => {
  const t = useTranslation()
  return (
    <div className='store-informations-services'>
      <div className='store-informations-services-list'>
        <div className='store-informations-services-item'>
          <p className='store-informations-services-item-title'>{t('Type of store:', {}, true)}</p>
          <p className='store-informations-services-item-values'>
            <span>{seller.type}</span>
          </p>
        </div>
        <div className='store-informations-services-item'>
          <p className='store-informations-services-item-title'>
            {t('Catégories de Produits:', {}, true)}
          </p>
          <p className='store-informations-services-item-values'>
            {seller.categories.map((c) => (
              <span key={c}>{c}</span>
            ))}
          </p>
        </div>
      </div>

      <div className='store-description'>{seller.description}</div>
    </div>
  )
}

export default StoreInformationsServices
